var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"200px","height":"200px","margin":"auto","margin-bottom":"40px"},attrs:{"id":"qrcode"}})
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }